import { render, staticRenderFns } from "./ServicePolicy.vue?vue&type=template&id=51f52beb&scoped=true"
import script from "./ServicePolicy.vue?vue&type=script&lang=js"
export * from "./ServicePolicy.vue?vue&type=script&lang=js"
import style0 from "./ServicePolicy.vue?vue&type=style&index=0&id=51f52beb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f52beb",
  null
  
)

export default component.exports